/******************************************************************************************
 *	License Admin Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.licenseAdmin', []).controller(
    'LicenseAdminController',
    /* @ngInject */
    function($scope, LicenseAdminSearchSnapshot) {
      //Clear search snapshot
      //This is the controller of the root abstract view of all license admin states.
      //Meaning it's only instantiated once per license admin login.
      //Its $scope is $destroyed on logout only, making it the perfect place to clear search snapshot.
      $scope.$on('$destroy', function() {
        LicenseAdminSearchSnapshot.clear();
      });
    }
  );
})();
